import React from "react";

type SmartLinkProps = Omit<React.AnchorHTMLAttributes<HTMLAnchorElement>, "href"> & {
  href: string;
};

function isExternalHttpLink(href: string): boolean {
  if (typeof window === "undefined") return false;

  try {
    const url = new URL(href, window.location.href);

    if (url.protocol !== "http:" && url.protocol !== "https:") return false;

    return url.host !== window.location.host;
  } catch {
    return false;
  }
}

 const SmartLink = ({ href, target, rel, ...rest }: SmartLinkProps) => {
  let finalRel = rel;

  if (target === "_blank" && isExternalHttpLink(href)) {
    const tokens = new Set((rel ?? "").split(/\s+/).filter(Boolean));
    tokens.add("noopener");
    tokens.add("noreferrer");
    finalRel = Array.from(tokens).join(" ");
  }

  return <a href={href} target={target} rel={finalRel} {...rest} />;
}

export default SmartLink;